import { TAB_ANALYTICS, TAB_PUBLICATIONS, TAB_STORIES, TAB_TEMPLATES } from '@opengov/stories-shared/constants';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';

import { ISettings, IStoryListMessages, ITabOptions } from '../../../../types';

import { styles } from './Navigation.styles';

export type INavigationProps = {
  canOrganizeStories: boolean;
  isAdmin: boolean;
  messages: IStoryListMessages;
  settings: ISettings;
  tab: ITabOptions;
  displayPublicationTab: boolean;
  hideStoriesTab: boolean | null;
  updateTab(tab: string): void;
};

export const Navigation: React.FC<INavigationProps> = ({
  canOrganizeStories,
  isAdmin,
  messages,
  settings: { advanced },
  tab,
  displayPublicationTab,
  updateTab,
}) => {
  const visibleTabs = [
    displayPublicationTab && TAB_PUBLICATIONS,
    isAdmin && TAB_STORIES,
    isAdmin && !canOrganizeStories && TAB_TEMPLATES,
    isAdmin && advanced.google_analytics_id && TAB_ANALYTICS,
  ].filter(Boolean);
  const tabValue = visibleTabs.includes(tab) ? tab : false;

  return (
    <Box sx={styles.container}>
      <Tabs
        value={tabValue}
        onChange={(_, newTab) => updateTab(newTab)}
        textColor="primary"
        indicatorColor="primary"
        aria-label="Main navigation"
      >
        {displayPublicationTab && (
          <Tab
            data-test="stories-publication-tab"
            label={messages.publications}
            value={TAB_PUBLICATIONS}
          />
        )}
        {isAdmin && (
          <Tab
            data-test="stories-tab"
            label={messages.stories}
            value={TAB_STORIES}
          />
        )}
        {isAdmin && !canOrganizeStories && (
          <Tab
            data-test="stories-templates-tab"
            label={messages.templates}
            value={TAB_TEMPLATES}
          />
        )}
        {isAdmin && advanced.google_analytics_id && (
          <Tab
            data-test="stories-analytics-tab"
            label={messages.analytics}
            value={TAB_ANALYTICS}
          />
        )}
      </Tabs>
    </Box>
  );
};
